import { useState } from "react";
import { Loader2, Inbox, Images, FileText, Users, ShieldAlert } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { usePageMeta } from "../hooks/usePageMeta";
import { RequestsTab } from "../components/admin/RequestsTab";
import { ProjectsTab } from "../components/admin/ProjectsTab";
import { ContentsTab } from "../components/admin/ContentsTab";
import { AdminsTab } from "../components/admin/AdminsTab";

const TABS = [
  { id: "richieste", label: "Richieste", icon: Inbox },
  { id: "lavori", label: "Lavori", icon: Images },
  { id: "contenuti", label: "Contenuti", icon: FileText },
  { id: "amministratori", label: "Amministratori", icon: Users },
];

export default function Admin() {
  usePageMeta("Pannello Admin | Costruzioni Ciosko", "Gestione del sito Costruzioni Ciosko.");
  const { user, isAdmin, loading, login } = useAuth();
  const [tab, setTab] = useState("richieste");

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin text-forest-glow" size={30} /></div>;
  }
  if (!user) {
    return (
      <section className="min-h-screen flex items-center justify-center px-5 pt-20">
        <div className="text-center">
          <p className="text-cement mb-6">Area riservata. Accedi con un account autorizzato.</p>
          <button data-testid="admin-login-button" onClick={login} className="btn-primary">Accedi con Google</button>
        </div>
      </section>
    );
  }
  if (!isAdmin) {
    return (
      <section className="min-h-screen flex items-center justify-center px-5 pt-20">
        <div data-testid="admin-denied" className="text-center max-w-md">
          <ShieldAlert size={36} className="mx-auto text-red-400" />
          <h1 className="font-display font-bold text-xl text-white uppercase mt-4">Accesso negato</h1>
          <p className="text-cement text-sm mt-3 leading-relaxed">
            L'account {user.email} non è tra gli amministratori autorizzati. L'accesso viene concesso dal proprietario.
          </p>
        </div>
      </section>
    );
  }

  return (
    <section data-testid="admin-panel" className="min-h-screen pt-28 pb-20">
      <div className="max-w-7xl mx-auto px-5 lg:px-10">
        <p className="overline-label flex items-center gap-3">
          <span className="inline-block w-8 h-px bg-forest-mid" aria-hidden="true" /> Gestione sito
        </p>
        <h1 className="h-display text-2xl sm:text-3xl mt-4 text-white">Pannello amministratore</h1>
        <p className="text-cement text-sm mt-2">{user.email}</p>

        <div className="mt-8 flex gap-2 overflow-x-auto pb-2 border-b border-steel" role="tablist">
          {TABS.map((t) => (
            <button
              key={t.id}
              data-testid={`admin-tab-${t.id}`}
              role="tab"
              aria-selected={tab === t.id}
              onClick={() => setTab(t.id)}
              className={`flex items-center gap-2 px-4 py-2.5 text-[11px] font-semibold uppercase tracking-[0.12em] whitespace-nowrap border-b-2 transition-colors ${
                tab === t.id ? "border-forest-glow text-white" : "border-transparent text-cement hover:text-white"
              }`}
            >
              <t.icon size={14} /> {t.label}
            </button>
          ))}
        </div>

        <div className="mt-8">
          {tab === "richieste" && <RequestsTab />}
          {tab === "lavori" && <ProjectsTab />}
          {tab === "contenuti" && <ContentsTab />}
          {tab === "amministratori" && <AdminsTab />}
        </div>
      </div>
    </section>
  );
}
